import InputText from "../elements/Input/InputText";
import useFormLoginAdmin from "../components/loginAdmin/hooks/useFormLogin";

function LoginAdmin() {
  const { loading, handleSubmit } = useFormLoginAdmin();

  return (
    <div className="bg-gray-100 h-screen flex items-center justify-center">
      <div className="bg-white shadow-lg rounded-xl py-14 px-8 sm:px-20 md:px-10 lg:px-10">
        <h2 className="text-2xl font-semibold mb-2 text-center text-black">
          Masuk Admin
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <InputText
              type="text"
              containerStyle="mt-4"
              labelTitle="Username"
              inputName={"username"}
            />

            <InputText
              type="password"
              containerStyle="mt-4"
              inputName={"password"}
              labelTitle="Password"
            />
          </div>

          <button
            type="submit"
            className="btn mt-2 w-full btn-primary border-blue-600 bg-blue-600 hover:bg-blue-700 hover:border-blue-700 text-white disabled:bg-blue-300 disabled:border-blue-300 disabled:hover:cursor-not-allowed disabled:text-white"
            disabled={loading ? true : false}
          >
            Masuk
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginAdmin;
